import useShallowRouting from './useShallowSearchParams';

type Props = {
  id: string;
  name: string;
};
export default function useDistinctFacetSelected(props: Props) {
  const { id, name } = props;
  const { shallowSearchParams } = useShallowRouting();

  const shallowSearchParam = shallowSearchParams?.get(id.toLowerCase());

  if (!shallowSearchParam) return false;

  const facets = shallowSearchParam?.split(',');

  return facets?.includes(name);
}
